(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5129],{

/***/ 30716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ vzdelavacie_programy; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/AcademyAdvantages/AcadamyAdvantages.tsx + 1 modules
var AcadamyAdvantages = __webpack_require__(43532);
// EXTERNAL MODULE: ./src/components/AcademyMethods/AcademyMethods.tsx + 1 modules
var AcademyMethods = __webpack_require__(73342);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/components/AcademyProduct2/AcademyProduct.tsx + 1 modules
var AcademyProduct = __webpack_require__(82935);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/AcademyProducts2/AcademyProducts.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductselements__Wrapper",
  componentId: "sc-11jj9ps-0"
})(["margin:", " 0 ", " 0;padding:", " 0;@media (min-width:", "px){display:flex;flex-direction:column;}@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md);
var EmptyMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "AcademyProductselements__EmptyMessage",
  componentId: "sc-11jj9ps-1"
})(["display:block;text-align:center;padding-bottom:", ";color:", ";line-height:", ";font-size:", ";"], (0,polished_esm/* rem */.hO)(40), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h6;
});
var ShowMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductselements__ShowMore",
  componentId: "sc-11jj9ps-2"
})(["display:flex;justify-content:center;"]);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Spinner/Spinner.tsx + 1 modules
var Spinner = __webpack_require__(77368);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/services/calendar.service.ts
var calendar_service = __webpack_require__(2253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/AcademyProducts2/AcademyProducts.tsx















var AcademyProductsTemplate = function AcademyProductsTemplate(_ref) {
  var _ref3;

  var events = _ref.events,
      eventsCount = _ref.eventsCount;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = (0,react.useState)(null),
      poduajtia = _useState2[0],
      setPodujatia = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      totalCount = _useState3[0],
      setTotalCount = _useState3[1];

  var showMore = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _yield$calendarApi$ge, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return calendar_service/* calendarApi.getAcademies */.w.getAcademies(5, poduajtia.length);

            case 3:
              _yield$calendarApi$ge = _context.sent;
              data = _yield$calendarApi$ge.data;
              setPodujatia([].concat((0,toConsumableArray/* default */.Z)(poduajtia), (0,toConsumableArray/* default */.Z)(data === null || data === void 0 ? void 0 : data.results)));
              setTotalCount(data === null || data === void 0 ? void 0 : data.total_count);
              setIsLoading(false);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function showMore() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (events.length > 0) {
      setPodujatia(events);
      setTotalCount(eventsCount);
    }
  }, [events]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('academy.trainings.title')
    }), totalCount > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [(_ref3 = (0,toConsumableArray/* default */.Z)(poduajtia)) === null || _ref3 === void 0 ? void 0 : _ref3.map(function (event, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(AcademyProduct/* default */.Z, {
          event: event
        }, key);
      }), (poduajtia === null || poduajtia === void 0 ? void 0 : poduajtia.length) < totalCount && /*#__PURE__*/(0,jsx_runtime.jsx)(ShowMore, {
        children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
          size: 32
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          marginTop: 30,
          whiteType: true,
          onClick: showMore,
          text: t('homepage.calendar.button.more')
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyMessage, {
      children: t('academy.trainings.emptyMessage')
    })]
  });
};

/* harmony default export */ var AcademyProducts = (AcademyProductsTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/ui/Hero/Hero.tsx + 1 modules
var Hero = __webpack_require__(29135);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/pages/vzdelavacie-programy.tsx














var Academy = function Academy(_ref) {
  var events = _ref.events,
      eventsCount = _ref.eventsCount;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.academy.title'),
      description: "",
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero/* default */.Z, {
      titleKey: "academy.hero.title",
      imageKey: "educationalPrograms.webp",
      descriptionKey: "academy.hero.description",
      listKeys: ['academy.hero.paragraph1', 'academy.hero.paragraph2', 'academy.hero.paragraph3', 'academy.hero.paragraph4']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AcademyMethods/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(AcademyProducts, {
      events: events,
      eventsCount: eventsCount
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AcadamyAdvantages/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ var vzdelavacie_programy = (Academy);

/***/ }),

/***/ 58596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Lecturer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.elements.tsx



var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Wrapper",
  componentId: "sc-1urcrvf-0"
})(["display:inline-flex;align-items:center;margin-right:", ";margin-bottom:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10));
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Lecturerelements__ImageSection",
  componentId: "sc-1urcrvf-1"
})(["position:relative;width:", ";height:", ";overflow:hidden;border-radius:50%;margin-right:", ";margin-bottom:", ";@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(32), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(2), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(32));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Lecturerelements__Image",
  componentId: "sc-1urcrvf-2"
})(["position:absolute;left:50%;top:50%;width:100%;height:auto;transform:translate(-50%,-50%);"]);
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Title",
  componentId: "sc-1urcrvf-3"
})(["font-weight:", ";color:", ";"], function (prop) {
  return prop.isBold ? prop.theme.fontWeights.textBold : prop.theme.fontWeights.textRegular;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.tsx







var LecturerTemplate = function LecturerTemplate(_ref) {
  var image = _ref.image,
      isBold = _ref.isBold,
      name = _ref.name,
      slug = _ref.slug;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    onClick: function onClick() {
      return slug && router.push({
        pathname: "".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(slug)
      });
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageSection, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: image
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: name
    })]
  });
};

/* harmony default export */ var Lecturer = (LecturerTemplate);

/***/ }),

/***/ 19033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ formatLecturerName; }
/* harmony export */ });
var formatLecturerName = function formatLecturerName(person) {
  if (!person) return;
  return "".concat(person.titles.before_name ? "".concat(person.titles.before_name, " ") : '').concat(person.name, " ").concat(person.surname).concat(person.titles.after_name ? ", ".concat(person.titles.after_name) : '');
};

/***/ }),

/***/ 21835:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vzdelavacie-programy",
      function () {
        return __webpack_require__(30716);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,4623,1595,3342,9774,2888,179], function() { return __webpack_exec__(21835); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);